import RefreshIcon from '@mui/icons-material/Refresh';
import {Alert, AlertTitle, Button, DialogActions, DialogContent} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import type * as React from 'react';
import {useTranslation} from 'react-i18next';

type Props = {
    show: boolean;
    handleReload: () => void;
    handleKeepMine: () => void;
};

// No onClose on purpose: the user has to pick one, backdrop clicks and Escape do nothing.
const StaleEnrollmentModal: React.FC<Props> = ({
    show,
    handleReload,
    handleKeepMine,
}: Props): React.ReactElement => {
    const {t} = useTranslation();

    return (
        <Dialog open={show} maxWidth='sm' fullWidth aria-labelledby='stale-enrollment-title'>
            <DialogContent>
                <Alert severity='error' variant='filled' sx={{fontSize: '1.1rem'}}>
                    <AlertTitle id='stale-enrollment-title' sx={{fontSize: '1.4rem'}}>
                        {t('staleEnrollmentTitle')}
                    </AlertTitle>
                    {t('staleEnrollmentBody')}
                </Alert>
            </DialogContent>
            <DialogActions sx={{px: 3, pb: 2}}>
                <Button color='secondary' variant='outlined' onClick={handleKeepMine}>
                    {t('staleEnrollmentKeepMine')}
                </Button>
                <Button
                    color='primary'
                    variant='outlined'
                    startIcon={<RefreshIcon />}
                    onClick={handleReload}
                    sx={{px: 4}}
                >
                    {t('staleEnrollmentReload')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default StaleEnrollmentModal;
